import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let ksi = localStorage.getItem('KSI')
    let body = (typeof request.body == 'string')?   JSON.parse(request.body as string) : request.body
    if (request.method.toLowerCase() == 'post' && ksi) {
      request = request.clone({
        body: { ...body, KSI: ksi }
      })
    }
    return next.handle(request);
  }
}
